import { useAppDispatch } from './state'
import {
  getProducts as getProductsAPI,
  getProduct as getProductApi
} from '../api/products'
import {
  setIsLoading,
  setProduct,
  setProducts
} from '../state/slices/products_slice'

export const useProducts = () => {
  const dispatch = useAppDispatch()

  const getProducts = async () => {
    dispatch(setIsLoading(true))
    try {
      const result = await getProductsAPI()

      if (result.data) {
        dispatch(setProducts(result.data))
      }
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  const getProduct = async (id: string) => {
    dispatch(setIsLoading(true))
    try {
      const result = await getProductApi(id)

      dispatch(setProduct(result.data))
    } finally {
      dispatch(setIsLoading(false))
    }
  }

  return {
    getProducts,
    getProduct
  }
}

export default useProducts
